<app-loader [isBusy]="isBusy">
    <ng-template>
        <form class="p-3" [formGroup]="form">
            <div class="row">
                <div class="col">
                    <form-dropdown
                        labelText="{{ 'Type' | translate }}"
                        formControlName="typeId"
                        [codeListValues]="chatTypes"
                        (valueChange)="chatTypeSelectionChange($event)"></form-dropdown>
                </div>
                <div class="col">
                    <form-dropdown
                        codeListName="Organization"
                        labelText="{{ 'For Organization' | translate }}"
                        formControlName="forOrganizationId"
                        (valueChange)="organizationSelectionChange($event)"></form-dropdown>
                </div>
                <div class="col">
                    <form-dropdown
                        labelText="{{ 'For User' | translate }}"
                        formControlName="forUserId"
                        [observableInput]="users$"></form-dropdown>
                </div>
                @if (form.get('typeId').value === 'FOR_ORG') {
                    <div class="col">
                        <form-dropdown
                            codeListName="Organization"
                            labelText="{{ 'Watcher' | translate }}"
                            formControlName="watcherOrganizationId"></form-dropdown>
                    </div>
                }
            </div>
            <div class="row mt-2">
                <div class="col">
                    <form-textbox labelText="{{ 'Note' | translate }}" formControlName="note"></form-textbox>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-12">
                    <kendo-fileselect
                        [restrictions]="attachmentFileUploadRestrictions"
                        [multiple]="false"
                        (select)="fileSelected($event)"
                        (remove)="fileRemoved($event)">
                        <kendo-upload-messages
                            select="{{ 'Select File...' | translate }}"
                            dropFilesHere="{{ 'Drop file here to select' | translate }}"></kendo-upload-messages>
                    </kendo-fileselect>
                </div>
            </div>
        </form>
        <kendo-dialog-actions class="mt-4 pr-1" layout="end">
            <button
                class="btn btn-sm btn-primary mr-2"
                kendoButton
                [disabled]="!form.valid"
                (click)="submitNewChatNot()">
                <fa-icon [icon]="['fas', 'paper-plane']"></fa-icon>
                &nbsp;&nbsp;{{ 'Send' | translate }}
            </button>
            <button class="btn btn-sm btn-secondary" kendoButton (click)="closeModalWindow(false)">
                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                &nbsp;&nbsp;{{ 'Cancel' | translate }}
            </button>
        </kendo-dialog-actions>
    </ng-template>
</app-loader>
